import { DateTime } from '@ksyos/date-time';
import { useSelector } from 'react-redux';
import { Cookies } from '@frontend/utils/cookies';
import type { ICallBackMomentAddEdit } from '../../../common/validation/callBackMoment';
import type { IReduxState } from '../../configureStore';
import { getFormattedFilledInCallBackMoments } from '../../../common/utils/getFormattedFilledInCallBackMoments';
import { List } from '../elements/List/List';
import { IconColor } from './common';
import { FormLabel } from './forms/FormLabel';
import { HorizontalFormGroupRead } from './forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from './forms/InputContainer';
import { IconText } from './textElements/iconText/IconText';

interface ICallBackMomentRead {
    callBackMoments: ICallBackMomentAddEdit[];
    requestPractitionerId: string | null;
}

export function CallBackMomentRead(props: ICallBackMomentRead) {
    const formattedMoments: string[] = getFormattedFilledInCallBackMoments(props.callBackMoments);
    const sessionUserId = useSelector((state: IReduxState) => state.authentication.id);
    let isAvailableStatusText: string;
    let status: IconColor | undefined;
    const isAvailableForCalling = checkAvailableForCalling(props.callBackMoments);

    if (formattedMoments.length === 0) {
        return null;
    }

    if (isAvailableForCalling) {
        isAvailableStatusText = 'Nu bereikbaar';
        status = IconColor.success;
    } else {
        isAvailableStatusText = 'Momenteel niet bereikbaar';
        status = IconColor.danger;
    }

    return (
        <>
            <div className="d-flex align-items-center mb-3">
                <h3 className="m-0">Terugbelmoment</h3>

                {sessionUserId !== props.requestPractitionerId && (
                    <IconText
                        className="ml-3"
                        color={status}
                        icon="telephone"
                        text={isAvailableStatusText}
                    />
                )}
            </div>
            <HorizontalFormGroupRead>
                <FormLabel>Dagen en tijden</FormLabel>
                <InputContainer>
                    <List
                        bold
                        items={formattedMoments}
                    />
                </InputContainer>
            </HorizontalFormGroupRead>
        </>
    );
}

function checkAvailableForCalling(callBackMoments: ICallBackMomentAddEdit[]) {
    const currentTimeFromServer = Number(new Cookies().get('server_time'));
    const currentDayOfWeek = DateTime.from(currentTimeFromServer).locale('en').format('dddd');
    const filledInCallBackMoments = callBackMoments.filter(
        (callBackMoment) =>
            callBackMoment.isChecked && (callBackMoment.periodOne.startTime || callBackMoment.periodTwo.startTime)
    );

    return filledInCallBackMoments.some(
        (filledInCallBackMoment) =>
            filledInCallBackMoment.dayOfWeek === currentDayOfWeek &&
            (checkPeriodActive(filledInCallBackMoment.periodOne, currentTimeFromServer) ||
                checkPeriodActive(filledInCallBackMoment.periodTwo, currentTimeFromServer))
    );
}

function checkPeriodActive(
    period: { endTime: string | null; startTime: string | null },
    currentTimeFromServer: number
) {
    const format = 'HH:mm';
    const currentTime = DateTime.from(currentTimeFromServer).locale('en').format(format);

    return (
        period.startTime &&
        period.endTime &&
        DateTime.parse(currentTime, format).isBetween(
            DateTime.parse(period.startTime, format),
            DateTime.parse(period.endTime, format)
        )
    );
}
